export default function LatestProd() {
    return (
        <>
            <div className="container">
            <h3 className="latestProdHead">Latest Products</h3>
            <div className="mechOnProd">
                <div className="mechOnProdIn">
                    <div className="mechOnProdImg">
                        <img src="./images/prod/pr3.png" alt=""/>
                    </div>
                    <div className="mechOnProdCon">
                        <h3>Producct 1</h3>
                        <p>Rs:-2300</p>
                    </div>
                </div>
                <div className="mechOnProdIn">
                    <div className="mechOnProdImg">
                        <img src="./images/prod/pr4.png" alt=""/>
                    </div>
                    <div className="mechOnProdCon">
                        <h3>Producct 1</h3>
                        <p>Rs:-2300</p>
                    </div>
                </div>
                <div className="mechOnProdIn">
                    <div className="mechOnProdImg">
                        <img src="./images/prod/pr5.png" alt=""/>
                    </div>
                    <div className="mechOnProdCon">
                        <h3>Producct 1</h3>
                        <p>Rs:-2300</p>
                    </div>
                </div>
                <div className="mechOnProdIn">
                    <div className="mechOnProdImg">
                        <img src="./images/prod/pr6.png" alt=""/>
                    </div>
                    <div className="mechOnProdCon">
                        <h3>Producct 1</h3>
                        <p>Rs:-2300</p>
                    </div>
                </div>
            </div>
            </div>
        </>
    )
}